<section class="dashboard">
  <header class="dashboard-header">
    <div>
      <h1>Dashboard</h1>
      <p class="dashboard-subtitle">
        Live metrics from your jobs and storefront orders
      </p>
    </div>
  </header>

  <div class="kpi-grid">
    <div class="kpi-card accent-blue">
      <div class="kpi-label">New orders (7d)</div>
      <div class="kpi-value">
        @if (loading()) {
          <span class="skeleton skeleton-value"></span>
        } @else {
          {{ kpis().newOrders }}
        }
      </div>
    </div>

    <div class="kpi-card accent-mint">
      <div class="kpi-label">Jobs in progress</div>
      <div class="kpi-value">
        @if (loading()) {
          <span class="skeleton skeleton-value"></span>
        } @else {
          {{ kpis().inProgress }}
        }
      </div>
    </div>

    <div class="kpi-card accent-sand">
      <div class="kpi-label">Quotes awaiting review</div>
      <div class="kpi-value">
        @if (loading()) {
          <span class="skeleton skeleton-value"></span>
        } @else {
          {{ kpis().awaitingQuote }}
        }
      </div>
    </div>

    <div class="kpi-card accent-mint">
      <div class="kpi-label">New jobs (7d)</div>
      <div class="kpi-value">
        @if (loading()) {
          <span class="skeleton skeleton-value"></span>
        } @else {
          {{ kpis().newJobs }}
        }
      </div>
    </div>
  </div>

  <div class="main-grid">
    <div class="panel">
      <div class="panel-head">
        <h2>Orders over time</h2>
        <span class="panel-hint">Last 12 months</span>
      </div>
      @if (loading()) {
        <div class="chart-canvas skeleton skeleton-chart"></div>
      } @else {
        <div class="chart-canvas chart-tall">
          <canvas
            baseChart
            [type]="'line'"
            [data]="ordersChart()"
            [options]="ordersOptions"
          ></canvas>
        </div>
      }
    </div>

    <div class="panel">
      <div class="panel-head">
        <h2>Jobs by status</h2>
      </div>
      @if (loading()) {
        <div class="chart-canvas skeleton skeleton-chart"></div>
      } @else if (customers().length === 0) {
        <p class="empty">No jobs yet.</p>
      } @else {
        <div class="chart-canvas chart-tall">
          <canvas
            baseChart
            [type]="'doughnut'"
            [data]="statusChart()"
            [options]="doughnutOptions"
          ></canvas>
        </div>
      }
    </div>
  </div>

  <div class="panel needs-action">
    <div class="panel-head">
      <h2>Needs action</h2>
      @if (!loading() && needsAction().length) {
        <span class="count-badge">{{ needsAction().length }}</span>
      }
    </div>

    @if (loading()) {
      <div class="skeleton skeleton-row"></div>
      <div class="skeleton skeleton-row"></div>
      <div class="skeleton skeleton-row"></div>
    } @else if (needsAction().length === 0) {
      <p class="empty">All caught up. Nothing needs your attention.</p>
    } @else {
      <ul class="action-list">
        @for (
          item of needsAction();
          track item.kind + "-" + item.title + "-" + item.subtitle
        ) {
          <li>
            <a class="action-row" [routerLink]="item.link">
              <span class="action-kind kind-{{ item.kind.toLowerCase() }}">{{
                item.kind
              }}</span>
              <span class="action-text">
                <strong>{{ item.title }}</strong>
                <small>{{ item.subtitle }}</small>
              </span>
              <span class="action-arrow" aria-hidden="true">&rarr;</span>
            </a>
          </li>
        }
      </ul>
    }
  </div>
</section>
